/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportAIDatasetRequest
 */
export interface ImportAIDatasetRequest {
    /**
     * 
     * @type {number}
     * @memberof ImportAIDatasetRequest
     */
    connection: number;
    /**
     * 
     * @type {string}
     * @memberof ImportAIDatasetRequest
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportAIDatasetRequest
     */
    replace: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportAIDatasetRequest
     */
    rename?: string | null;
}

export function ImportAIDatasetRequestFromJSON(json: any): ImportAIDatasetRequest {
    return ImportAIDatasetRequestFromJSONTyped(json, false);
}

export function ImportAIDatasetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportAIDatasetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'connection': json['connection'],
        'path': json['path'],
        'replace': json['replace'],
        'rename': !exists(json, 'rename') ? undefined : json['rename'],
    };
}

export function ImportAIDatasetRequestToJSON(value?: ImportAIDatasetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'connection': value.connection,
        'path': value.path,
        'replace': value.replace,
        'rename': value.rename,
    };
}


